import { Temporal } from '@js-temporal/polyfill';

export function formatMs(
  ms,
  {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale = (typeof navigator !== 'undefined' && navigator.language) || 'en-US',
    options = {},
  } = {}
) {
  const instant = Temporal.Instant.fromEpochMilliseconds(Number(ms));
  const zdt = instant.toZonedDateTimeISO(timeZone);

  return zdt.toLocaleString(locale, options);
}

export const formatDateShort = (
  ms,
  { timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, locale, options = {} } = {}
) => {
  return formatMs(ms, {
    timeZone,
    locale,
    options: { year: 'numeric', month: 'numeric', day: 'numeric', ...options },
  });
};

export const formatDatePretty = (
  ms,
  { timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, locale, options = {} } = {}
) => {
  return formatMs(ms, {
    timeZone,
    locale,
    options: { year: 'numeric', month: 'short', day: 'numeric', ...options },
  });
};

export const formatTimeShort = (
  ms,
  { timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, locale, options = {} } = {}
) => {
  return formatMs(ms, {
    timeZone,
    locale,
    options: { hour: 'numeric', minute: '2-digit', hour12: true, ...options },
  });
};

export default { formatMs, formatDateShort, formatDatePretty, formatTimeShort };
